var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEyeWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9547 9.20139C17.3193 9.67831 17.3193 10.3222 16.9547 10.7983C15.8062 12.2975 13.0508 15.3845 9.83392 15.3845C6.61699 15.3845 3.86161 12.2975 2.71315 10.7983C2.53575 10.57 2.43945 10.289 2.43945 9.99985C2.43945 9.71068 2.53575 9.42975 2.71315 9.20139C3.86161 7.70216 6.61699 4.61523 9.83392 4.61523C13.0508 4.61523 15.8062 7.70216 16.9547 9.20139V9.20139Z",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83504 12.3075C11.1095 12.3075 12.1427 11.2743 12.1427 9.99983C12.1427 8.72533 11.1095 7.69214 9.83504 7.69214C8.56053 7.69214 7.52734 8.72533 7.52734 9.99983C7.52734 11.2743 8.56053 12.3075 9.83504 12.3075Z",
    stroke: "white",
    strokeWidth: 1.53846,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeWhite);
export default __webpack_public_path__ + "static/media/eye-white.fc4fbe5c96c63def1e074168348316dc.svg";
export { ForwardRef as ReactComponent };